var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"be-skeleton-loader"},_vm._l((_vm.rows),function(idx){return _c('v-skeleton-loader',{key:idx,class:`mx-auto ${_vm.mt}`,attrs:{"transition":"slide-x-transition","type":_vm.type,"dark":_vm.isHighContrast}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }